import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { troyConfig } from "./data";

export default function TroyPage() {
  return <CityPageTemplate config={troyConfig} />;
}